import React from 'react';
import clsx from 'clsx';
import SwatchOption from './product-options/swatch-option';
import RadioOption from './product-options/radio-option';
import SelectOption from './product-options/select-option';

const VariantSelector = (props) => {
  const isSaverSet = props.product?.tags?.includes('thinx-set') || props.product?.tags?.includes('tfal-set');

  if (props.option.name.toLowerCase().includes('color') && !isSaverSet) {
    return <SwatchOption {...props} />;
  }
  if (props.option.name.toLowerCase().includes('size')) {
    return <RadioOption {...props} />;
  }
  return (
    <SelectOption
      classes={clsx({ hidden: isSaverSet })}
      {...props}
    />
  );
};

export default VariantSelector;
